import { useEffect, useState } from 'react';
import { useBookingContext } from '../Context';
import {
    BookerContextType,
    CalEventDataWithDisplayPrice,
} from '../types';
import { getFormattedPriceStr } from '../utils';
import { useFetchCalEvents } from './useCalEvents';

export const useEvents = () => {
    const bookerContext = useBookingContext();
    const { isLoading, fetchCalEvents } = useFetchCalEvents(bookerContext);
    const [calEventsMap, setCalEventsMap] = useState<Map<string, CalEventDataWithDisplayPrice>>(
        () => new Map()
    );
    const { organizationId, teamId, events } = bookerContext;

    const shouldFetchEvents = Boolean(
        organizationId && teamId && events.length > 0
    );

    useEffect(() => {
        // Early return if conditions are not met
        if (!shouldFetchEvents) {
            return;
        }
        
        fetchCalEvents({
            organizationId: organizationId!,
            teamId: teamId!,
        }).then((calEvents) => {
            // Map of calEventId to identifier
            const calEventIdToIdentifierMap = new Map(
                events.map((event) => [event.calEventId, event])
            );

            const map = new Map<string, CalEventDataWithDisplayPrice>();
            calEvents?.forEach((event) => {
                const currentEvent = calEventIdToIdentifierMap.get(event.id);
                if (currentEvent) {
                    const eventPrice = getFormattedPriceStr({
                        currentEvent: { priceInfo: currentEvent?.priceInfo },
                    } as BookerContextType);

                    map.set(currentEvent.identifier, {
                        ...event,
                        displayPrice: eventPrice,
                    });
                }
            });

            setCalEventsMap(map);
        });

        // we only want to fetch events once when the component mounts
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        isLoading,
        calEventsMap,
        shouldFetchEvents,
    };
};
